var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-toggle",
              rawName: "v-b-toggle",
              value: "list-invisible-training",
              expression: "'list-invisible-training'",
            },
          ],
          staticClass: "m-1",
          attrs: { variant: "info" },
        },
        [_vm._v("Liste des leçons")]
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        { attrs: { id: "list-invisible-training" } },
        [
          _c(
            "b-row",
            { staticClass: "mb-2", attrs: { "align-h": "end" } },
            [
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 text-right",
                  attrs: { cols: "3", "align-self": "end" },
                },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.modal-lesson-add",
                          modifiers: { "modal-lesson-add": true },
                        },
                      ],
                      attrs: { variant: "success" },
                    },
                    [_vm._v("Ajouter une nouvelle leçon")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-modal",
                    {
                      attrs: {
                        id: "modal-lesson-add",
                        title: "Ajouter une nouvelle leçon",
                        scrollable: "",
                        "hide-footer": "",
                      },
                    },
                    [
                      _c("form-training", {
                        attrs: {
                          offers: _vm.offers,
                          needs: _vm.needs,
                          usages: _vm.usages,
                          documents: _vm.documents,
                        },
                        on: { sendForm: _vm.receiveUpdate },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "text-center" },
                    [
                      _c("b-spinner", {
                        attrs: {
                          small: "",
                          variant: "primary",
                          type: "grow",
                          label: "Spinning",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-spinner", {
                        attrs: {
                          small: "",
                          variant: "primary",
                          type: "grow",
                          label: "Spinning",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-spinner", {
                        attrs: {
                          small: "",
                          variant: "primary",
                          type: "grow",
                          label: "Spinning",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "m-0 p-0" },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Filtrer",
                            "label-cols-sm": "3",
                            "label-align-sm": "left",
                            "label-size": "sm",
                            "label-for": "filterInput",
                          },
                        },
                        [
                          _c(
                            "b-input-group",
                            { attrs: { size: "sm" } },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "filterInput",
                                  type: "search",
                                  placeholder:
                                    "Taper pour rechercher une leçon de formation",
                                },
                                model: {
                                  value: _vm.filter,
                                  callback: function ($$v) {
                                    _vm.filter = $$v
                                  },
                                  expression: "filter",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "b-input-group-append",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { disabled: !_vm.filter },
                                      on: {
                                        click: function ($event) {
                                          _vm.filter = ""
                                        },
                                      },
                                    },
                                    [_vm._v("Effacer")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
          _vm._v(" "),
          _c("b-table", {
            key: _vm.reRender,
            attrs: {
              fields: _vm.fields,
              items: _vm.trainingLessons,
              filter: _vm.filter,
              "filter-included-fields": _vm.filterOn,
              small: "",
              responsive: "sm",
            },
            scopedSlots: _vm._u([
              {
                key: "cell(fle_id)",
                fn: function (row) {
                  return [_c("b-col", [_vm._v(_vm._s(row.item.fle_id))])]
                },
              },
              {
                key: "cell(fle_label)",
                fn: function (row) {
                  return [_c("b-col", [_vm._v(_vm._s(row.item.fle_label))])]
                },
              },
              {
                key: "cell(fle_description)",
                fn: function (row) {
                  return [
                    _c("b-col", [_vm._v(_vm._s(row.item.fle_description))]),
                  ]
                },
              },
              {
                key: "cell(fle_is_enable)",
                fn: function (row) {
                  return [
                    _c(
                      "b-col",
                      { staticClass: "badge-sizing" },
                      [
                        row.item.fle_is_enable
                          ? _c(
                              "b-badge",
                              { attrs: { sm: "", variant: "success" } },
                              [_vm._v("✔")]
                            )
                          : _c(
                              "b-badge",
                              { attrs: { sm: "", variant: "danger" } },
                              [_vm._v("𐄂")]
                            ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "cell(needs)",
                fn: function (row) {
                  return _vm._l(row.item.needs, function (need) {
                    return _c(
                      "b-col",
                      {
                        key: need.fne_id + "need" + row.item.fle_id,
                        staticClass: "mt-2 badge-sizing",
                      },
                      [
                        _c(
                          "b-badge",
                          { style: { "background-color": need.fne_color } },
                          [_vm._v(_vm._s(need.fne_label))]
                        ),
                      ],
                      1
                    )
                  })
                },
              },
              {
                key: "cell(usages)",
                fn: function (row) {
                  return _vm._l(row.item.usages, function (usage) {
                    return _c(
                      "b-col",
                      {
                        key: usage.fus_id + "usage" + row.item.fle_id,
                        staticClass: "mt-2 badge-sizing",
                      },
                      [
                        _c(
                          "b-badge",
                          { style: { "background-color": usage.fus_color } },
                          [_vm._v(_vm._s(usage.fus_label))]
                        ),
                      ],
                      1
                    )
                  })
                },
              },
              {
                key: "cell(offers)",
                fn: function (row) {
                  return _vm._l(row.item.offers, function (offer) {
                    return _c(
                      "b-col",
                      {
                        key: offer.off_id + "offer" + row.item.fle_id,
                        staticClass: "mt-2 badge-sizing",
                      },
                      [
                        _c("b-badge", { attrs: { variant: "secondary" } }, [
                          _vm._v(_vm._s(offer.off_name)),
                        ]),
                      ],
                      1
                    )
                  })
                },
              },
              {
                key: "cell(documents)",
                fn: function (row) {
                  return _vm._l(row.item.documents, function (document) {
                    return _c(
                      "b-col",
                      {
                        key: document.doc_id + "document" + row.item.fle_id,
                        staticClass: "mt-2 badge-sizing",
                      },
                      [
                        _c("b-badge", { attrs: { variant: "secondary" } }, [
                          _vm._v(_vm._s(document.doc_type)),
                        ]),
                        _vm._v(" "),
                        _c("b-badge", { attrs: { variant: "light" } }, [
                          _vm._v(_vm._s(document.doc_name)),
                        ]),
                      ],
                      1
                    )
                  })
                },
              },
              {
                key: "cell(update)",
                fn: function (row) {
                  return [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { staticClass: "mt-1" },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal",
                                    value:
                                      "modal-update-training-" +
                                      row.item.fle_id,
                                    expression:
                                      "'modal-update-training-'+ row.item.fle_id",
                                  },
                                ],
                                attrs: { size: "sm", variant: "primary" },
                              },
                              [_vm._v("Modifier")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-modal",
                          {
                            attrs: {
                              id: "modal-update-training-" + row.item.fle_id,
                              title: "Modifier une leçon",
                              scrollable: "",
                              "hide-footer": "",
                            },
                          },
                          [
                            _c("form-training", {
                              attrs: {
                                id: row.item.fle_id,
                                lesson: row.item,
                                offers: _vm.offers,
                                needs: _vm.needs,
                                usages: _vm.usages,
                                documents: _vm.documents,
                              },
                              on: { sendForm: _vm.receiveUpdate },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "mt-1" },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: row.item.fle_is_enable
                                    ? "warning"
                                    : "success",
                                  size: "sm",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeLessonStatus(row.item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    row.item.fle_is_enable
                                      ? "Désactiver"
                                      : "Activer"
                                  )
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "mt-1" },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "danger", size: "sm" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteLesson(row.item)
                                  },
                                },
                              },
                              [_vm._v("Supprimer")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }